// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","461":"b637e9a5","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"3973b3c95fb0e2aced18","293":"25ac55768f2194a0854f","461":"51c3c2cd9bf18a7ea83c","518":"22e85b626fcf6e9f1c46","779":"834feb82d5e7a1e81ff2"}[chunkId] + ".js";
};